import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import Badge from '@repo/ui/badge'
import { InformationIcon } from '@repo/ui/icons'
import Typography from '@repo/ui/typography'

import {
  PaymentTypeEnum,
  paymentTypeEnumMapping
} from '../../../../lib/types/enums/payment-record/payment-type.enum'
import { statusEnumMapping } from '../../../../lib/types/enums/payment-record/status.enum'
import { PaymentRecord } from '../../../../lib/types/models/payment-record/payment-record'
import InformationToolTip from '../../../elements/information-tooltip'

type PaymentRecordStatusBadgeProps = {
  paymentRecord: Pick<PaymentRecord, 'status' | 'type' | 'refundReason'>
}

const PaymentRecordStatusBadge = ({ paymentRecord }: PaymentRecordStatusBadgeProps) => {
  return (
    <Badge
      variant={statusEnumMapping[paymentRecord.status].variant}
      text={`${statusEnumMapping[paymentRecord.status].label} ${paymentTypeEnumMapping[paymentRecord.type].name}`}
      icon={
        paymentRecord.type === PaymentTypeEnum.REFUND &&
        paymentRecord.refundReason && (
          <InformationToolTip
            align="center"
            icon={<InformationIcon color={statusEnumMapping[paymentRecord.status].iconColor} />}
          >
            <Typography variant="label-semibold" color={tailwindColors.white.DEFAULT}>
              {paymentRecord.refundReason}
            </Typography>
          </InformationToolTip>
        )
      }
    />
  )
}

export default PaymentRecordStatusBadge
